import { useNavigate } from "react-router-dom";
import { ShapeSizeForm } from "@univdiam/ui/customComponents/ShapeSizeList/ShapesizeForm";
import api from "@/http/api";

export default function ShapeSizeAdd() {
  const navigate = useNavigate();

  const handleAddShapeSize = async (data: any) => {
    try {
      const response = await api.post(`/api/shape_size/add`, data);

      if (response.status === 201 || response.status === 200) {
        alert("ShapeSize created successfully!");
        navigate("/shape-size");
      }
    } catch (error) {
      console.error("Error creating group:", error);
      alert("Failed to create group.");
    }
  };

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Create New Shape Size</h1>
      <ShapeSizeForm onSubmit={handleAddShapeSize} />
    </div>
  );
}
